import PageError from "../../../app/PageError";
import { Button } from "react-bootstrap";
import { memo } from "react";
import { RouterPaths } from "../../../app/appConstants";
import { Link } from "react-router-dom";
import { useLangContext } from "../../../providers/LangProvider/LangProviderContext.js";

export const BrokenLink = memo(() => {
    const {getLangPath} = useLangContext();
    return (
            <PageError
                    description={getLangPath('email_confirmation.broken_link_description')}
                    headerText={getLangPath('email_confirmation.broken_link_title')}
                    icon="IcChainLink"
            >
                <div className="w-100 d-flex align-items-center flex-column mt-3">
                    <Link to={RouterPaths.forgot} className="w-100">
                        <Button size={'lg'}
                                variant={'info'}
                                className={'mb-4 w-100'}
                        >
                            {getLangPath('email_confirmation.request_link')}
                        </Button>
                    </Link>
                    <Link to={RouterPaths.login}>
                        <Button size={'md'} variant={'link'} className="color-white">
                            {getLangPath('sign_up.title')}
                        </Button>
                    </Link>
                </div>
            </PageError>
    )
});